export default __webpack_public_path__ + "static/media/banner.2d213eb4.png";